module.exports = __webpack_public_path__ + "static/media/service-req.71e15289.svg";